var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Callable } from "@renproject/utils";
import axios from "axios";
import { fixUTXO, fixUTXOs, sortUTXOs, DEFAULT_TIMEOUT, } from "./API";
export var SoChainNetwork;
(function (SoChainNetwork) {
    SoChainNetwork["BTC"] = "BTC";
    SoChainNetwork["LTC"] = "LTC";
    SoChainNetwork["ZEC"] = "ZEC";
    SoChainNetwork["DOGE"] = "DOGE";
    SoChainNetwork["DASH"] = "DASH";
    SoChainNetwork["BTCTEST"] = "BTCTEST";
    SoChainNetwork["LTCTEST"] = "LTCTEST";
    SoChainNetwork["ZECTEST"] = "ZECTEST";
    SoChainNetwork["DOGETEST"] = "DOGETEST";
    SoChainNetwork["DASHTEST"] = "DASHTEST";
})(SoChainNetwork || (SoChainNetwork = {}));
export class SoChainClass {
    constructor(network = SoChainNetwork.BTC) {
        this.fetchUTXO = (txHash, vOut) => __awaiter(this, void 0, void 0, function* () {
            const url = `https://sochain.com/api/v2/get_tx/${this.network}/${txHash}`;
            const response = yield axios.get(url, { timeout: DEFAULT_TIMEOUT });
            const tx = response.data.data;
            return fixUTXO({
                txHash: tx.txid,
                amount: tx.outputs[vOut].value.toString(),
                vOut,
                confirmations: tx.confirmations,
            }, 8);
        });
        this.fetchUTXOs = (address, confirmations = 0) => __awaiter(this, void 0, void 0, function* () {
            const url = `https://sochain.com/api/v2/get_tx_unspent/${this.network}/${address}/${confirmations}`;
            const response = yield axios.get(url, { timeout: DEFAULT_TIMEOUT });
            return fixUTXOs(response.data.data.txs.map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.value.toString(),
                // scriptPubKey: utxo.script_hex,
                vOut: utxo.output_no,
                confirmations: utxo.confirmations,
            })), 8)
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        });
        this.fetchTXs = (address, confirmations = 0) => __awaiter(this, void 0, void 0, function* () {
            const url = `https://sochain.com/api/v2/get_tx_received/${this.network}/${address}/${confirmations}`;
            const response = yield axios.get(url, { timeout: DEFAULT_TIMEOUT });
            return fixUTXOs(response.data.data.txs.map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.value.toString(),
                // scriptPubKey: utxo.script_hex,
                vOut: utxo.output_no,
                confirmations: utxo.confirmations,
            })), 8)
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        });
        this.broadcastTransaction = (txHex) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(`https://sochain.com/api/v2/send_tx/${this.network}`, { tx_hex: txHex }, { timeout: DEFAULT_TIMEOUT });
            return response.data.data.txid;
        });
        this.network = network;
    }
}
export const SoChain = Callable(SoChainClass);
//# sourceMappingURL=sochain.js.map